import 'element-ui/lib/theme-chalk/index.css'

import '@/assets/css/bootstrap.min.css'
import '@/assets/css/font-awesome.min.css'
import '@/assets/css/font-flaticon.css'
import '@/assets/css/search.css'
import '@/assets/css/style.css'

import Vue from 'vue'

import {
	Breadcrumb,
	BreadcrumbItem,
	Button,
	Card,
	Col,
	Container,
	Dialog,
	Image,
	Notification,
	Main,
	Row,
	Select,
	Table,
	TableColumn
} from 'element-ui'
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Button)
Vue.use(Card)
Vue.use(Col)
Vue.use(Container)
Vue.use(Dialog)
Vue.use(Image)
Vue.use(Main)
Vue.use(Row)
Vue.use(Select)
Vue.use(Table)
Vue.use(TableColumn)

Vue.prototype.$notify = Notification

import axios from 'axios'
import router from './router'
import store from './store'

import Other from './Other.vue'

Vue.config.productionTip = false
Vue.prototype.$http = axios

axios.defaults.baseURL = '/api/atlas'

new Vue({
	router,
	store,
	render: h => h(Other)
}).$mount('#other')
